import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row w-100" }
const _hoisted_2 = { class: "card-body w-50" }
const _hoisted_3 = { class: "card-body w-50" }
const _hoisted_4 = { class: "pb-10 pb-lg-15" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder d-flex align-items-center text-dark mb-6" }, [
  /*#__PURE__*/_createTextVNode(" Subject Location "),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Subject Location"
  })
], -1)
const _hoisted_6 = { class: "fv-row mb-10" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Please specify the exact location(s) of subjects during research activity. "),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "popover",
    "data-bs-trigger": "hover",
    "data-bs-html": "true",
    title: "e.g., when data is collected or during an intervention"
  })
], -1)
const _hoisted_8 = { class: "mb-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold mb-6 fs-6 required" }, "Please Specifiy ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDownSection = _resolveComponent("DropDownSection")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DropDownSection, {
        title: "Review for more information",
        list: _ctx.listDropDownSections
      }, null, 8, ["list"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", null, [
            _createVNode(_component_el_select, {
              class: "form-select-solid",
              placeholder: "Select option",
              modelValue: _ctx.step3.q4_1,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.step3.q4_1) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "Gannon University Campus",
                  value: "Gannon University Campus"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Gannon University Campus")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_option, {
                  label: "Hospital Setting",
                  value: "Hospital Setting"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Hospital Setting")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_option, {
                  label: "Community Center",
                  value: "Community Center"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Community Center")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_option, {
                  label: "Outpatient Clinic",
                  value: "Outpatient Clinic"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Outpatient Clinic")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_option, {
                  label: "Nursing Home",
                  value: "Nursing Home"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Nursing Home")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_option, {
                  label: "Elementary/Secondary School",
                  value: "Elementary/Secondary School"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Elementary/Secondary School")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_option, {
                  label: "Prison/Halfway Houses",
                  value: "Prison/Halfway Houses"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Prison/Halfway Houses")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_option, {
                  label: "International Location",
                  value: "International Location"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("International Location")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_option, {
                  label: "Other, specify",
                  value: "Other, specify"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Other, specify")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_option, {
                  label: "Electronic/Remote Only (e.g., zoom interviews, electronic surveys)",
                  value: "Electronic/Remote Only (e.g., zoom interviews, electronic surveys)"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Electronic/Remote Only (e.g., zoom interviews, electronic surveys).")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createVNode(_component_Field, {
          type: "hidden",
          name: "q4_1",
          modelValue: _ctx.step3.q4_1,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.step3.q4_1) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_ErrorMessage, {
          name: "q4_1",
          class: "fv-plugins-message-container invalid-feedback"
        }),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_Field, {
            type: "text",
            class: "form-control form-control-solid",
            placeholder: "",
            initialValue: "",
            name: "q4_2",
            modelValue: _ctx.step3.q4_2,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step3.q4_2) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_component_ErrorMessage, {
          name: "q4_2",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ])
    ])
  ]))
}